import api from "./api";

// Türkçe karakterleri İngilizce karşılıklarına çeviren fonksiyon
const turkishToEnglish = (text) => {
  const turkishChars = {
    'ç': 'c', 'Ç': 'C',
    'ğ': 'g', 'Ğ': 'G', 
    'ı': 'i', 'I': 'I',
    'İ': 'I', 'i': 'i',
    'ö': 'o', 'Ö': 'O',
    'ş': 's', 'Ş': 'S',
    'ü': 'u', 'Ü': 'U'
  };
  
  return text.replace(/[çÇğĞıIİiöÖşŞüÜ]/g, function(match) {
    return turkishChars[match] || match;
  });
};

// Slug oluşturan fonksiyon
const createSlug = (text) => {
  return turkishToEnglish(text)
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Boşlukları tire ile değiştir
    .replace(/[^a-z0-9-]/g, '')     // Sadece harf, rakam ve tire bırak
    .replace(/-+/g, '-')            // Çoklu tireleri tek tire yap
    .replace(/^-|-$/g, '');         // Başta ve sonda tire varsa kaldır
};

export const getProducts = async (params = {}) => {
  try {
    const res = await api.get("/products/", { params });
    return res.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

export const getProduct = async (identifier) => {
  try {
    console.log('Fetching product:', identifier);
    const res = await api.get(`/products/${identifier}`);
    console.log('Product received:', res.data);
    return res.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getProductBySlug = async (slug) => {
  try {
    const res = await api.get(`/products/${slug}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    throw error;
  }
};

export const getProductById = async (id) => {
  try {
    const res = await api.get(`/products/id/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error fetching product by id:", error);
    throw error;
  }
};

export const createProduct = async (data) => {
  try {
    // Multi-language slug generation
    const slugData = data.slug || {
      tr: createSlug(data.title.tr || ''),
      en: createSlug(data.title.en || data.title.tr || ''),
      es: createSlug(data.title.es || data.title.tr || '')
    };
    
    console.log("Multi-language product slug generation:");
    console.log(`  TR: "${data.title.tr}" -> "${slugData.tr}"`);
    console.log(`  EN: "${data.title.en || data.title.tr}" -> "${slugData.en}"`);
    console.log(`  ES: "${data.title.es || data.title.tr}" -> "${slugData.es}"`);
    
    const formattedData = {
      slug: slugData,
      categoryId: data.categoryId,
      title: data.title,
      summary: data.summary,
      content: data.content,
      seo: data.seo,
      subProducts: data.subProducts || []
    };
    
    console.log("Sending product data:", formattedData);
    
    const res = await api.post("/products/", formattedData, {
      timeout: 60000, // 60 saniye timeout (büyük veriler için)
    });
    return res.data;
  } catch (error) {
    console.error("=== ERROR CREATING PRODUCT ===");
    console.error("Error:", error.message);
    console.error("Error code:", error.code);
    
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
      
      // 422 hatası için detaylı bilgi göster
      if (error.response.status === 422 && error.response.data?.detail) {
        console.error("=== VALIDATION ERRORS ===");
        error.response.data.detail.forEach((err, index) => {
          console.error(`Error ${index + 1}:`, err);
        });
      }
      
      console.error("Response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Request made but no response received:", error.request);
    }
    
    // Network hatalarını daha anlaşılır hale getir
    if (error.code === 'ECONNABORTED') {
      throw new Error('İstek zaman aşımına uğradı. Lütfen tekrar deneyin.');
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Ağ bağlantısı hatası. İnternet bağlantınızı kontrol edin.');
    } else if (error.code === 'ERR_TUNNEL') {
      throw new Error('Sunucu bağlantı hatası. Lütfen daha sonra tekrar deneyin.');
    }
    
    throw error;
  }
};

export const updateProduct = async (id, data) => {
  try {
    // Multi-language slug generation
    const slugData = data.slug || {
      tr: createSlug(data.title.tr || ''),
      en: createSlug(data.title.en || data.title.tr || ''),
      es: createSlug(data.title.es || data.title.tr || '')
    };
    
    console.log("Multi-language product slug update:");
    console.log(`  TR: "${data.title.tr}" -> "${slugData.tr}"`);
    console.log(`  EN: "${data.title.en || data.title.tr}" -> "${slugData.en}"`);
    console.log(`  ES: "${data.title.es || data.title.tr}" -> "${slugData.es}"`);
    
    const formattedData = {
      slug: slugData,
      categoryId: data.categoryId,
      title: data.title,
      summary: data.summary,
      content: data.content,
      seo: data.seo,
      subProducts: data.subProducts || []
    };
    
    // Order varsa ekle
    if (data.order !== undefined && data.order !== null) {
      formattedData.order = parseInt(data.order, 10);
    }
    
    console.log("Updating product data:", formattedData);
    console.log("Product ID:", id);
    
    const res = await api.put(`/products/${id}`, formattedData, {
      timeout: 60000, // 60 saniye timeout (büyük veriler için)
    });
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPDATING PRODUCT ===");
    console.error("Product ID:", id);
    console.error("Error:", error.message);
    console.error("Error code:", error.code);
    
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
      
      // 422 hatası için detaylı bilgi göster
      if (error.response.status === 422 && error.response.data?.detail) {
        console.error("=== VALIDATION ERRORS ===");
        error.response.data.detail.forEach((err, index) => {
          console.error(`Error ${index + 1}:`, err);
        });
      }
      
      console.error("Response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Request made but no response received:", error.request);
    }
    
    // Network hatalarını daha anlaşılır hale getir
    if (error.code === 'ECONNABORTED') {
      throw new Error('İstek zaman aşımına uğradı. Lütfen tekrar deneyin.');
    } else if (error.code === 'ERR_NETWORK') {
      throw new Error('Ağ bağlantısı hatası. İnternet bağlantınızı kontrol edin.');
    } else if (error.code === 'ERR_TUNNEL') {
      throw new Error('Sunucu bağlantı hatası. Lütfen daha sonra tekrar deneyin.');
    }
    
    throw error;
  }
};

// Sadece order alanını güncelle
export const updateProductOrder = async (id, order) => {
  try {
    console.log("→ Sending product order update:", { id, order });
    
    // Order değerini integer olarak gönder
    const res = await api.put(`/products/${id}`, {
      order: parseInt(order, 10)
    });
    
    console.log("← Received response:", res.data);
    return res.data;
  } catch (error) {
    console.error("✗ Product order update failed:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteProduct = async (id) => {
  try {
    const res = await api.delete(`/products/${id}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting product:", error);
    throw error;
  }
};

export const uploadProductImage = async (id, file) => {
  try {
    console.log("=== UPLOADING PRODUCT IMAGE ===");
    console.log("Product ID:", id);
    console.log("Product ID length:", id ? id.length : 'undefined');
    console.log("Product ID type:", typeof id);
    console.log("File:", file.name, file.size, "bytes", file.type);
    
    // ID format validation
    if (!id || typeof id !== 'string' || id.length !== 24) {
      throw new Error(`Invalid product ID format. Expected 24-char string, got: "${id}" (${typeof id}, length: ${id ? id.length : 'undefined'})`);
    }
    
    const formData = new FormData();
    formData.append("image", file); // API dokümantasyonuna göre 'image' field adı
    
    console.log("Making request to:", `/products/${id}/images`);
    const res = await api.post(`/products/${id}/images`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    console.log("Upload successful:", res.data);
    return res.data;
  } catch (error) {
    console.error("=== ERROR UPLOADING PRODUCT IMAGE ===");
    console.error("Error:", error.message);
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
      console.error("Response headers:", error.response.headers);
    }
    throw error;
  }
};

// Ürün dökümanı yükleme
export const uploadProductDocument = async (id, file, label, type = "manual") => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("label", label);
    formData.append("type", type);
    console.log("Uploading product document for ID:", id);
    const res = await api.post(`/products/${id}/documents`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (error) {
    console.error("Error uploading product document:", error);
    if (error.response) {
      console.error("Response data:", error.response.data);
      console.error("Response status:", error.response.status);
    }
    throw error;
  }
};

export const deleteProductImage = async (id, imageId) => {
  try {
    const res = await api.delete(`/products/${id}/images/${imageId}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting product image:", error);
    throw error;
  }
};

// Bulk image delete - yeni API
export const bulkDeleteImages = async (imageUrls) => {
  try {
    console.log("=== BULK DELETE IMAGES ===");
    console.log("URLs to delete:", imageUrls);
    console.log("Request URL:", `${api.defaults.baseURL}/images/`);
    
    const requestData = {
      urls: imageUrls
    };
    console.log("Request data:", requestData);
    
    const res = await api.delete("/images/", {
      data: requestData,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    console.log("Bulk delete response:", res.data);
    console.log("Response status:", res.status);
    return res.data;
  } catch (error) {
    console.error("=== BULK DELETE ERROR ===");
    console.error("Error message:", error.message);
    console.error("Error code:", error.code);
    
    if (error.response) {
      console.error("Response status:", error.response.status);
      console.error("Response data:", error.response.data);
      console.error("Response headers:", error.response.headers);
    } else if (error.request) {
      console.error("Request made but no response received:", error.request);
    }
    
    throw error;
  }
};


export const deleteProductDocument = async (id, documentId) => {
  try {
    const res = await api.delete(`/products/${id}/documents/${documentId}`);
    return res.data;
  } catch (error) {
    console.error("Error deleting product document:", error);
    throw error;
  }
};
